import type { StoreSet, StoreGet } from './index';

export type DashboardDraftConfig = {
  type: string;
  timerange: string;
  title: string;
  query: string;
  searchType: string;
  countby: string | null;
  sensors: Array<{ value: string; label: string }>;
  sort: { value: string; label: string };
  limit: number;
};

export type DashboardDraftSlice = {
  defaultDraft: DashboardDraftConfig;
  // drafts are stored dynamically keyed by dashboard id
  drafts: Record<string, unknown>;
  setDraft: (dashboardId: string, draft: unknown) => void;
  setDefaultDraft: (dashboardId: string) => void;
  getDraft: (dashboardId: string) => unknown;
  removeDraft: (dashboardId: string) => void;
};

const DEFAULT_DRAFT: DashboardDraftConfig = {
  type: 'table',
  timerange: 'global',
  title: '',
  query: '',
  searchType: 'O_SENSOR',
  countby: null,
  sensors: [{ value: 'global', label: 'Dashboard selection' }],
  sort: { value: 'desc', label: 'desc' },
  limit: 50,
};

const createDashboardDraft = (set: StoreSet, get: StoreGet): DashboardDraftSlice => ({
  defaultDraft: DEFAULT_DRAFT,
  drafts: {},
  setDraft: (dashboardId, draft) => {
    set((prev) => ({
      dashboardDraft: {
        ...prev.dashboardDraft,
        drafts: { ...prev.dashboardDraft.drafts, [dashboardId]: draft },
      },
    }));
  },
  setDefaultDraft: (dashboardId) => {
    set((prev) => ({
      dashboardDraft: {
        ...prev.dashboardDraft,
        drafts: { ...prev.dashboardDraft.drafts, [dashboardId]: { config: DEFAULT_DRAFT } },
      },
    }));
  },
  getDraft: (dashboardId) => {
    return get().dashboardDraft.drafts[dashboardId];
  },
  removeDraft: (dashboardId) => {
    set((prev) => {
      const draft = prev.dashboardDraft.drafts[dashboardId];
      if (!draft) {
        return prev;
      }
      const { [dashboardId]: _, ...rest } = prev.dashboardDraft.drafts;
      return {
        dashboardDraft: { ...prev.dashboardDraft, drafts: rest },
      };
    });
  },
});

export default createDashboardDraft;
